import { Checkbox, Form } from 'antd';
import classNames from 'classnames';
import type { NamePath } from 'rc-field-form/es/interface';

import { isPassed } from 'app/utils/dates';

import '../Cells.scss';

type CheckboxCellProps = {
  date: Date;
  nameField?: NamePath;
  disabled?: boolean;
};

export const CheckboxCell = ({
  date,
  nameField,
  disabled = false,
}: CheckboxCellProps) => {
  return (
    <div className={classNames('inventory-cell', 'edit-mode')}>
      <div
        className={classNames({
          'edit-mode-activate': true,
        })}
      >
        <Form.Item noStyle name={nameField} valuePropName="checked">
          <Checkbox disabled={isPassed(date) || disabled} />
        </Form.Item>
      </div>
    </div>
  );
};
